export default __webpack_public_path__ + "static/media/Fire_svg.ccdcee87.svg";